import PhoneInput from "@common/controls/Inputs/PhoneInput/component";
import React from "react";
import TextInput, { type TextInputProps } from "./component";
import EmailInput from "./Email";
import { getInputInfo } from "./lib";

type Props = Omit<TextInputProps, "type">;
const AddressInput = React.forwardRef((props: Props, ref: React.RefObject<any>) => {
  const ii = React.useMemo(() => getInputInfo(props.name), [props.name]);

  const type = React.useMemo((): string => {
    const name = (props.name ?? "").toLowerCase();

    if (name.includes("email")) {
      return "email";
    }

    return "text";
  }, [props.name]);

  const name = (props.name ?? "").toLowerCase();

  if (name.includes("email")) {
    return <EmailInput ref={ref} {...props} maxLength={ii?.maxLength} />;
  }

  if (name.includes("telephone")) {
    return <PhoneInput ref={ref} {...props} maxLength={ii?.maxLength} />;
  }

  return <TextInput ref={ref} {...props} autoComplete={ii?.autoComplete} maxLength={ii?.maxLength} type={type} />;
});
export default AddressInput;
